import axios from "@/utils/axios";

const UI_ACTION_TRACKING_ENABLED = (import.meta as any).env.VITE_UI_ACTION_TRACKING_ENABLED && (import.meta as any).env.VITE_UI_ACTION_TRACKING_ENABLED === 'true';

export async function trackAction(action: string, params: Record<any, any> = {}) {
    try {
        if(UI_ACTION_TRACKING_ENABLED){
            const response = await axios.post("/tracking", {
                action,
                params: {...params, path: window.location.pathname}
            });
            return response.data;
        }
    } catch (error) {
        console.error("[Tracking Error]:", error);
        return null;
    }
}